module.exports = __webpack_public_path__ + "static/negz-d73d18a8b7994524dc39a6ea3fcf43fc.jpg";